import React, { forwardRef } from 'react';
import Select, { SelectProps } from '@mui/material/Select';

export const DataGridBaseSelect = forwardRef<HTMLElement, SelectProps>(({ children, ...props }, ref) => {
  return (
    <Select
      ref={ref}
      {...props}
      sx={{
        height: '100%',
        fontSize: '0.875rem',
        '.MuiOutlinedInput-notchedOutline': { border: 'none' },
      }}
      MenuProps={{
        ...props.MenuProps,
        MenuListProps: {
          sx: { '.MuiButtonBase-root': { fontSize: '0.875rem', textTransform: 'none', minHeight: 36 } },
        },
        PaperProps: { sx: { maxHeight: 256 } },
      }}
    >
      {children}
    </Select>
  );
});
